module.exports = __webpack_public_path__ + "static/media/gp1.33117c97.webp";